import React from 'react';
import './Banner.css';

import { Heading } from '../../components';

import { FaHeadset } from 'react-icons/fa';



// Banner component that can handle both variations
const Banner = ({ variant, subHeading, mainHeading, contactInfo, cta }) => {

  return (
    <section className="banner">
      <div className="content">
        {variant === 'support' ? (

          // Support Center Banner
          <div className='support-banner'>
            <Heading title={mainHeading} subTitle={subHeading} linear />
            <a href={cta.link} className="btn">{cta.text}</a>
          </div>

        ) : variant === 'dual' ? (

          // Dual Banner with promotion and contact info
          <div className="dual-banner">

            <div className="banner-1">
              <Heading title={mainHeading} subTitle={subHeading} linear sideHeading />
              <a href={cta.link} className="btn">{cta.text}</a>
            </div>

            <div className="banner-2">
              <h4>Contact Us</h4>
              <div className="banner-icon">
                <span></span><div className='icon'><FaHeadset /></div><span></span>
              </div>
              {contactInfo && (
                <>
                  <h6>{contactInfo.phone}</h6>
                  <h6>{contactInfo.email}</h6>
                </>
              )}
              <a href={contactInfo.ctaLink} className="btn">{contactInfo.ctaText} </a>
            </div>

          </div>
        ) : null}
      </div>
    </section>
  );
};

// Usage examples:

// 1. Support Center Banner
export const SupportBanner = () => (
  <Banner
    variant="support"
    subHeading="Support Center"
    mainHeading="Providing Reliable Support for Your Security Systems"
    cta={{ text: "Contact Support", link: "../../pages/Contact/Contact.html" }}
  />
);

// 2. Dual Banner with promotion and contact info


export default Banner;